import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import InstitutionReview from '@/features/institution/review/components/review';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingReviewPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="authorisation" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionReview />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingReviewPage.displayName = 'InstitutionOnboardingReviewPage';

export default InstitutionOnboardingReviewPage;
